import Box from '@mui/material/Box';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { Headline } from '../../../../../design/components/Typography';

export const UserBackgroundHistoriesTitle: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    return (
        <Box pt={4}>
            <Headline variant="h4">{translate('pages.recruiter-profile.background.title')}</Headline>
        </Box>
    );
};
